export default __webpack_public_path__ + "static/media/alex-mueller.484acff7.png";